<template>
  <button
    class="race-list-close-timetable-button"
    :class="{ 'race-list-close-timetable-button--for-pc': forPc }"
    @click="handleCloseClicked"
  >
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.1016 6.53918L10.2783 12.3624C9.59492 13.0458 8.48688 13.0458 7.80347 12.3624L1.98024 6.53919L4.10156 6.53919L8.86413 11.3017C8.96176 11.3994 9.12005 11.3994 9.21768 11.3017L13.9802 6.53918L16.1016 6.53918Z"
        fill="white"
      />
    </svg>
  </button>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'

export default defineComponent({
  name: 'RaceListCloseTimetableButtonParts',
  setup(_, { emit }) {
    const forPc = DeviceInfo.isForPC()
    const handleCloseClicked = () => {
      emit('onClickClose')
    }
    return {
      forPc,
      handleCloseClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.race-list-close-timetable-button {
  position: fixed;
  top: 58px;
  right: 10px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: rgba(#000, 0.2);
  border-radius: 50%;

  &--for-pc {
    top: 58px;
    left: 424px;
  }
}
</style>
